import { Notification } from 'types/notification.types';
import { getOpenInNewTabMenuOption } from 'app/components/ChakraTableList';

export const getRowData = (notification: Notification) => {
  const isInteractive = Boolean(notification.rel);
  const { initials, profileImages, avatarColors } = notification.sender || {};
  const menuOptions = [
    ...(isInteractive
      ? getOpenInNewTabMenuOption(notification.rel as string)
      : []),
  ];

  return {
    isInteractive,
    rowData: { notification, options: menuOptions },
    initials,
    profileImages,
    avatarColors,
  };
};

interface OnRowClickProps {
  notification: Notification;
  markNotificationAsRead: (guid: string) => void;
  onClick?: (notification: Notification) => void;
}

export const onRowClick = ({
  notification,
  markNotificationAsRead,
  onClick,
}: OnRowClickProps) => {
  const isInteractive = Boolean(notification.rel);
  if (isInteractive && notification.read === false && markNotificationAsRead) {
    markNotificationAsRead(notification.guid);
  }
  if (onClick) {
    onClick(notification);
  }
};
